export const getPartnersMaintenance = state =>
	!!(state.service.maintenance && state.service.maintenance.partners);
